import { addons } from '@storybook/manager-api';

import krakenFlexTheme from './krakenFlexTheme';

addons.setConfig({
  theme: krakenFlexTheme,
});
